export const GLOWGHOST_MARK_SRC = '/brand/modul-mark.svg';
